import request, { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios"
import Cache from "./cache"
import Env from "./env"
const GET = "get"
const POST = "post"
const PUT = "put"
const Cacher = new Cache()

interface IHttp {
  _doXhr: (
    config: AxiosRequestConfig,
    callback: (error: any, result: any) => void
  ) => void
  request: (
    config: AxiosRequestConfig,
    withHeader?: boolean,
    cacheOption?: any
  ) => Promise<any>
  get: <T extends object = {}>(
    url: string,
    param?: T,
    options?: T
  ) => Promise<any>
  post: <T extends object = {}>(
    url: string,
    param?: T,
    options?: T
  ) => Promise<any>
  put: <T extends object = {}>(
    url: string,
    param?: T,
    options?: T
  ) => Promise<any>
}

const Http: IHttp = {
  /**
   * 发送请求
   */
  _doXhr: function(conf: AxiosRequestConfig, callback) {
    request(conf)
      .then(function(res: AxiosResponse) {
        let error = null
        let result: any = undefined
        if (res.status === 200) {
          result = res.data
        } else {
          error = res.statusText
        }
        if (result.code && result.code !== 200) {
          console.warn(conf.url, result)
          if (
            result.code === 301013 ||
            result.code === 211028 ||
            result.code === 301106
          ) {
            // 获取token失败 重新登录
            // window.location.hash = "/auth"
            // x-frame-orgin
            Env.logout()
          }
          result.msg = result.msg || result.message || result.data
        }
        callback && callback(error, result)
      })
      .catch((error: AxiosError) => {
        let response = error.response || {
          status: -99999,
          statusText: "unknown error"
        }
        if (response.status === 401 || response.status === 403) {
          window.location.hash = "/auth"
        }
        callback && callback(error, response)
      })
  },

  request: function(
    conf: AxiosRequestConfig,
    withHeader?: boolean,
    cacheOption?: any
  ) {
    if (withHeader) {
      let { potoken } = Env.getUser()
      conf.headers = {
        token: potoken,
        Authorization: potoken
      }
    }
    let noCacheValue = true
    let needCache = false
    return new Promise((resolve, reject) => {
      if (cacheOption && cacheOption.key) {
        needCache = true
        let now = +new Date()
        let store = cacheOption.store || window["sessionStorage"]
        let key = cacheOption.key
        let resCache = Cacher.get(store, key)
        if (cacheOption.fromCache && resCache && resCache.expire >= now) {
          noCacheValue = false
          window.setTimeout(function() {
            // fix react setstate in constructor
            resolve(resCache.data)
          }, 10)
        }
      }
      if (noCacheValue) {
        this._doXhr(conf, function(err: any, res: any) {
          if (err) {
            reject(err)
          } else {
            if (needCache) {
              let now = +new Date()
              Cacher.set(
                cacheOption.store || window["sessionStorage"],
                cacheOption.key,
                {
                  data: res,
                  expire: now + cacheOption.expire * 1000
                }
              )
            }
            resolve(res)
          }
        })
      }
    })
  },
  get: function(url, param, options) {
    let cf = {
      method: GET,
      url: url,
      params: param
    }
    return this.request(cf, true, options)
  },

  post: function(url, param, options) {
    let cf = {
      method: POST,
      url: url,
      data: param
    }
    return this.request(cf, true, options)
  },
  put: function(url, param) {
    let cf = {
      method: PUT,
      url: url,
      data: param
    }
    return this.request(cf, true)
  }
}

export default Http
